<template>
  <section class="c-feature">
    <div class="c-heading">
      <h1 class="c-heading__title primary-title">locations</h1>
      <SearchBar v-on:searchByAddress="searchByAddress" :searchPerformed="searchPerformed"
        :performingSearch="performingSearch" :query="query" />
      <!-- <ComingSoon :locations="comingSoonLocations" v-if="comingSoonLocations" /> -->
    </div>
    <div class="c-feature__interior-container c-feature__interior-container--locations"
      v-if="storeList.length === 0 && !performingGeoSearch">
      <h2 v-if="searchPerformed">No hoots wings found</h2>
      <h2 v-else>Search for hoots wings</h2>
      <p v-if="searchPerformed">Try entering another city, state or zipcode</p>
      <p v-else>Use the search bar to find stores near you</p>
    </div>
    <div class="c-feature__interior-container c-feature__interior-container--locations" v-if="performingGeoSearch">
      <h2>Loading...</h2>
      <p>Searching for Hoots Wings locations near you.</p>
    </div>
    <div class="c-feature__interior-container c-feature__interior-container--locations"
      v-for="(location, index) in storeList" :key="index">
      <div class="c-feature-location">
        <div class="c-feature-location__column">
          <div class="c-feature-location__store-info c-feature-location__store-info--contact">
            <div v-if="location.c_locationSlug">
              <div class="favorite-selector selected" v-if="
                favoriteLocation &&
                location.c_locationName === favoriteLocation.c_locationName
              ">
                <img :src="`${assetPath}images/icons/star-icon-selected.svg`" alt="Map Icon" />
                <span> your favorite</span>
              </div>
              <div class="favorite-selector" v-else @click="setFavoriteLocation(location)">
                <img :src="`${assetPath}images/icons/star-icon.svg`"
                  :alt="`Make ${location.shortName} my favorite location`" />
                <span :aria-label="
                  `Make ${location.shortName} my favorite location`
                ">
                  make favorite</span>
              </div>
            </div>
            <div class="c-feature-location__store-name">
              <p>{{ location.c_locationName }}</p>
            </div>
            <div class="c-feature-location__store-address" v-if="location.locationDynamicFields">
              <p>
                <b>{{ getOpenHours(location) }}</b>
              </p>
            </div>

            <div class="c-feature-location__store-address">
              <p>
                {{ location.address['line1'] }}<br />
                <span v-if="location.address_2">
                  {{ location.address_2 }} <br />
                </span>
                {{ location.address.city }}, {{ location.address.region }}
                {{ location.address.postalCode }}
              </p>
            </div>
            <a :href="`tel:${location.mainPhone}`" class="c-feature-location__store-map-link"
              :aria-label="`tel:${location.mainPhone}`" v-if="location.mainPhone">
              <img :src="`${assetPath}images/icons/phone-icon.svg`" :alt="`Store Phone: ${location.mainPhone}`"
                v-if="location.mainPhone" />
              <span>{{ location.mainPhone }}</span></a>
            <a :href="mapUrl(location)" target="_blank" class="c-feature-location__store-map-link"
              aria-label="Get directions">
              <img :src="`${assetPath}images/icons/map-icon.svg`" alt="Get Directions" />
              <span>Get Directions</span>
            </a>
          </div>
        </div>
        <div class="c-feature-location__column">
          <a class="c-feature-location__cta c-cta c-cta--orange-outline" :href="location.orderUrl"
            aria-label="Order online" v-if="location.orderUrl && location.orderUrl != null"><img class="button-icon"
              :src="`${assetPath}images/icons/wing-icon.svg`" alt="Order online" />
            <span>ORDER ONLINE</span>
          </a>
          <router-link class="c-feature-location__cta c-cta c-cta--orange-outline"
            :to="locationRoute(location.c_locationSlug)"><img
              class="button-icon details-icon" :src="`${assetPath}images/icons/details-icon.svg`"
              alt="get store details" />
            <span>store details</span>
          </router-link>
          <a class="c-feature-location__cta c-cta c-cta--orange-outline" :href="location.c_cateringURL"
            v-if="location.c_cateringURL">
            <img class="button-icon circle-icon" :src="`${assetPath}images/icons/catering-icon.svg`"
              alt="get catering link" />
            <span>get catering</span>
          </a>
        </div>
        <div class="c-feature-location__column">
          <a :href="mapUrl(location)" target="_blank" :aria-label="`${location.name} Location Map Link`"
            class="c-feature-location__store-info-map" :style="
  `background: url(/perch/resources/${location.mapTileImg.path}) center center;background-size:cover`
            " ref="mapTile">
          </a>
        </div>
      </div>
      <hr />
    </div>
  </section>
</template>

<script>
import SearchBar from '@/components/SearchBar';
import ComingSoon from '@/components/location/ComingSoon';
import { store } from '@/store';
import fetchLocations from '../services/fetchLocation';
export default {
  name: 'App',
  components: {
    SearchBar,
    ComingSoon,
  },
  data() {
    return {
      userPos: null, // This will hold our users geoCoordinates.  Used for searching and displaying results by proximity
      storeList: [], // Holds our list of locations
      searchPerformed: false,
      favoriteLocation: null,
      performingSearch: false,
      query: this.$route.params.query
        ? this.$route.params.query.replace(/-/g, ' ')
        : null,
      assetPath: store.assetPath(), // Should point to public accessible urls for images
      perchPath: store.perchPath(), // Should to path on the file system for images
      showHours: false,
      performingGeoSearch: true,
    };
  },

  async mounted() {
    var self = this;

    // grab our locations from graphql closepoint.
    self.storeList = await fetchLocations();

    // check if we have a favorite location set
    self.favoriteLocation = store.getInitialFavoriteLocation();

    // Run our geolocator function.
    if (!self.query) {
      navigator.geolocation.getCurrentPosition(
        self.locationRequestSuccess,
        self.locationRequestError
      );
    } else {
      self.searchByAddress(self.query);
    }

    document.querySelectorAll(
      '.c-masthead__cover'
    )[0].style.backgroundImage = `url('/perch/resources/mastheads/hootsmastheadchooseyourthing.jpg')`;
    document.querySelectorAll(
      '.c-masthead__cover'
    )[1].style.backgroundImage = `url('/perch/resources/mastheads/hootsmastheadchooseyourthingm.jpg')`;
  },
  methods: {
    tConvert(time) {
      // Check correct time format and split into components
      time = time
        .toString()
        .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

      delete time[4];

      if (time.length > 1) {
        // If time format correct
        time = time.slice(1); // Remove full string match value
        time[4] = +time[0] < 12 ? ' am' : ' pm'; // Set AM/PM
        time[0] = +time[0] % 12 || 12; // Adjust hours
      }
      return time.join(''); // return adjusted time or original string
    },
    forceHttps(location) {
      return location.replace(/^http:\/\//i, 'https://');
    },
    forceHttps(location) {
      if (location) {
        return location.replace(/^http:\/\//i, 'https://');
      } else {
        return location;
      }
    },
    dynamicSort(property) {
      let sortOrder = 1;

      if (property[0] === '-') {
        sortOrder = -1;
        property = property.substr(1);
      }

      return function (a, b) {
        if (sortOrder == -1) {
          return b[property].localeCompare(a[property]);
        } else {
          return a[property].localeCompare(b[property]);
        }
      };
    },

    setFavoriteLocation(location) {
      store.setFavoriteLocation(location);
      this.favoriteLocation = store.getFavoriteLocation();
    },

    mapUrl(location) {
      if (location.c_mapUrl) {
        return location.c_mapUrl;
      }

      return `https://www.google.com/maps/place/${encodeURI(
        location.address['line1']
      )},+${location.address.city},+${location.address.region}+${location.address.postalCode
        }`;
    },
    // function that runs when a user grants access to location data.
    // This should sort the list of locations from closest to farthest
    // based on proximity to the user.  We are using the location data
    // that we got from the geo request.
    locationRequestSuccess(position) {
      this.userPos = [position.coords.latitude, position.coords.longitude];

      // function to calculate how far a location is from the user based on
      // geoCoordinates
      this.calculateDistances(this.userPos);
      this.performingGeoSearch = false;
    },

    // function that should run when a user denies the location request
    // permission or for any other failure to retrieve location data.
    async locationRequestError() {
      const locations = await fetchLocations();

      /**
       * Mike B requested that in this case we show the user a list of locations
       * in alphabetical order but with the Georgia stores first.  This was
       * originally relying on some custom logic in /perch/addons/apps/hoots_locations/lib/HootsLocations_Locations.php
       */

      // initialize two arrays, one to hold our Georgia stores and one to hold all the others
      let gaLocations = [];
      let otherLocations = [];

      for (const location of locations) {
        if (location.address.region.toLowerCase() === 'ga') {
          gaLocations.push(location);
        } else {
          otherLocations.push(location);
        }
      }

      this.storeList = [
        ...gaLocations.sort(this.dynamicSort('c_locationName')),
        ...otherLocations.sort(this.dynamicSort('c_locationName')),
      ];

      this.performingGeoSearch = false;
    },
    calculateDistance(lat1, lon1, lat2, lon2) {
      let deg2rad = this.deg2rad;
      var R = 6371;
      var dLat = deg2rad(lat2 - lat1);
      var dLon = deg2rad(lon2 - lon1);
      var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(deg2rad(lat1)) *
        Math.cos(deg2rad(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      var d = R * c;
      return d;
    },
    deg2rad(deg) {
      return deg * (Math.PI / 180);
    },
    async calculateDistances(origin) {
      const stores = [];
      const destinations = [];

      const localLocations = this.storeList.filter(
        location => location.visible
      );
      localLocations.map(location => {
        //Loop over our object and convert any jsonencoded strings back to json.
        Object.keys(location).map(val => {
          if (location[val] && typeof location[val] === 'string') {
            if (location[val].includes('{') || location[val].includes('["'))
              try {
                location[val] = JSON.parse(location[val]);
              } catch (error) {
                console.error('Unable to convert string to object');
              }
          }
        });
      });
      localLocations.forEach(async store => {
        if (!store.geocodedCoordinate) {
          // Yext didn't give us coordinates.  Probably because no phone number attached to the store.
          // Will need to query Google and add it ourselves.
          const searchString = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURI(
            store.address.line1 +
            ',' +
            store.address.city +
            ',' +
            store.address.region
          )}&key=AIzaSyD0hSY4zvK1XXZJ801LePuCTLMpJ00wu_A`;
          // const searchString = `https://geocoder.api.here.com/6.2/geocode.json?app_id=mFcz0JdMabmyM0WDE1G5&app_code=NYX4xhoHKkgBiCPT-A7evw&searchtext=`;
          const res = await this.$http.get(searchString);

          const { lat, lng } = res.data.results[0].geometry.location;
          store.geocodedCoordinate = { latitude: lat, longitude: lng };
        }
        if (store.geocodedCoordinate) {
          const { latitude, longitude } = store.geocodedCoordinate;
          store.distance = Math.floor(
            this.calculateDistance(latitude, longitude, origin[0], origin[1])
          );
        }

        stores.push(store);
        destinations.push(store);
        stores.sort(function (a, b) {
          if (a.distance > b.distance) {
            return 1;
          }
          if (a.distance < b.distance) {
            return -1;
          }
          return 0;
        });
        //Ensure that we only show stores in the same country.
        this.storeList = stores.filter(store => store.visible);
      });
    },

    async searchByAddress(location) {
      //Click search button, mostly so we can record a user interaction in Google Analytics
      document.querySelector('.search-icon').click();
      //Update the URL
      this.$router.push(`/locations/search/${location}`);

      this.performingSearch = false;

      //If user doesn't supply position, try to get it from the server.
      if (!this.userPos) {
        const locations = await fetchLocations();
        this.userPos = locations;
      }

      const searchString = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURI(
        location
      )}&key=AIzaSyD0hSY4zvK1XXZJ801LePuCTLMpJ00wu_A`;
      // const searchString = `https://geocoder.api.here.com/6.2/geocode.json?app_id=mFcz0JdMabmyM0WDE1G5&app_code=NYX4xhoHKkgBiCPT-A7evw&searchtext=`;
      const res = await this.$http.get(searchString);

      const { lat, lng } = res.data.results[0].geometry.location;
      this.calculateDistances([lat, lng]);

      this.searchPerformed = true;
    },

    locationRoute(slug) {
      return `/locations/details/${slug}`;
    },
    getOpenHours(location) {
      const weekday = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
      const d = new Date();
      let day = weekday[d.getDay()];
      let dynamicFields;
      if (location && location.hours) {
        if (typeof location.hours === 'object' &&
          !Array.isArray(location.hours) &&
          location.hours !== null
        ) {
          dynamicFields = location.hours;
        } else {
          dynamicFields = JSON.parse(location.hours);
        }
        if (dynamicFields[day].open === '00:00:00' & dynamicFields[day].close === '00:00:00') {
          return "Closed Today"
        } else {
          return "Open today from " + this.tConvert(dynamicFields[day].open) + " to " + this.tConvert(dynamicFields[day].close);
        }
      } else {
        return '';
      }
    },
  },
  computed: {
    comingSoonLocations() {
      let locations = this.storeList.filter(store => store.comingSoon);
      let results = locations
        .filter(a => a.comingSoon)
        .sort(function (a, b) {
          let dateA = new Date(
            a.c_comingSoonText.toLowerCase().split('coming ')[1]
          );
          let dateB = new Date(
            b.c_comingSoonText.toLowerCase().split('coming ')[1]
          );
          if (dateA > dateB) {
            return 1;
          }
          if (dateA < dateB) {
            return -1;
          }
          return 0;
        });

      if (results.length > 0) {
        return results.slice(0, 3);
      } else {
        return null;
      }
      return null;
    },
  },
};
</script>
